<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-row>
        <!-- Inicio Panel FILTRO -->
        <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
          <vs-card>
            <div slot="header">
              <h3 class="card-title mb-0">Información de filtro</h3>
            </div>
            <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
            <vs-row>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <!-- Selector de empresa -->
                <company-selector v-model="companyId"/>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Fecha de inicio</label>
                <vs-input type="date" v-model="initialDate" class="w-100 "/>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Fecha de fin</label>
                <vs-input type="date" v-model="finalDate" class="w-100 "/>
              </vs-col>
            </vs-row>
            <br/>
            <vs-row>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Tiquete id</label>
                <vs-input type="Text" v-model="query" class="w-100 "/>
              </vs-col>
              <!-- Selector de detallado v-if="thereStations" -->
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Usuario de purga</label>
                <vs-input type="Text" v-model="userPurge" class="w-100 "/>
              </vs-col>
            </vs-row>
            <hr class="custom-hr"/>
            <div class="d-inline-block d-md-flex align-items-center">
              <div class="btn-alignment">
                <vs-button @click="listPurgeRecord()">Buscar</vs-button>
                <vs-button color="gray" @click="clearForm()">Limpiar</vs-button>
              </div>
              <div class="ml-auto mt-3 mt-md-0">
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center dropdownbtn-alignment ml-3">
                    <vs-button class="btnx" type="filled" color="danger"
                               @click="download()">
                      <i class="ti-upload mr-2"></i>Exportar
                    </vs-button>

                    <vs-dropdown>
                      <vs-button class="btn-drop" type="filled" color="danger" icon="expand_more"></vs-button>
                      <vs-dropdown-menu>
                        <vs-button class="dropdown-item" color="'default'" v-for="document in documents"
                                   :value="document.id" :key="document.id"
                                   :id="document.id" @click="formatType=document.id">{{ document.name }}
                        </vs-button>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </vs-card>
        </vs-col>
        <vs-col vs-lg="12" vs-xs="12" v-if="showTable">
          <vs-card>
            <h3 class="card-title d-flex">
              Tabla de previsualización
            </h3>
            <div class="border" style="max-height: 43em;
              overflow-y: auto;">
              <vs-table max-items="50" pagination :data="tableData">
                <template slot="thead">
                  <vs-th>Id tiquete</vs-th>
                  <vs-th>Fecha de ingreso</vs-th>
                  <vs-th>Usuario de purga</vs-th>
                  <vs-th>Fecha de purga</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr,indextr) in data">
                    <vs-td :data="data[indextr].id">
                      {{ data[indextr].id }}
                    </vs-td>
                    <vs-td :data="data[indextr].dateIn">
                      {{ data[indextr].dateIn }}
                    </vs-td>
                    <vs-td :data="data[indextr].userPurge">
                      {{ data[indextr].userPurge }}
                    </vs-td>
                    <vs-td :data="data[indextr].datePurge">
                      {{ data[indextr].datePurge }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
    </vs-col>
  </vs-row>


</template>


<script>
import Treeselect from "@riophae/vue-treeselect";
import {ROUTES} from "@/global/api_routes";
import DateUtils from "../../../../global/DateUtils";
import toast from "@/global/ToastConfig";
import moment from "moment";
import CompanySelector from "../../../../components/Shared/CompanySelector";
import Multiselect from "vue-multiselect";
import parkingReportsEndpoints from "@/endpoints/reports/parking-reports/parkingReportsEndpoints";

export default {
  name: "purge-records-report",
  watch: {
    selectedDate() {
      this.dateSend = moment(this.selectedDate).format("YYYY-MM-DD");
    },
    companyId() {
      this.tableData = [];
      this.showTable = false;
    },
    /**
     * Observa el initialDate y realiza una accion si este cambia
     */
    initialDate() {
      this.tableData = [];
      this.showTable = false;
    },
    /**
     * Observa el finalDate y realiza una accion si este cambia
     */
    finalDate() {
      this.tableData = [];
      this.showTable = false;
    },
  },
  components: {Treeselect, CompanySelector, Multiselect},
  data: () => ({
    tableData: [],
    companyId: null,
    query: null,
    userPurge: null,
    isLoading: false,
    selectedFather: null,
    formatType: 'xlsx',
    selected: null,
    selectedDate: null,
    dataSend: null,
    finalDate: new Date(),
    initialDate: null,
    document: null,
    documents: [
      {name: "Excel", id: "xlsx"},
      {name: "Pdf", id: "pdf"},
    ],
    movementSelected: null,
    showTable: false,
    showModal: false,
  }),

  methods: {
    view(record) {
      console.log(record);
      this.movementSelected = record;
      this.showModal = true;
    },
    closeModal() {
      this.$emit("closeModal");
      this.showModal = false;
    },
    clearForm() {
      this.company = null;
      this.selected = null;
      this.formatType = null;
      this.initialDate = null;
      this.finalDate = null;
    },
    getDayType(document) {
      switch (document) {
      }
    },

    prepareParameters() {
      // se listan mis parametros del reporte
      return {
        companyId: this.companyId,
        initialDate: DateUtils.toDateShortString({
          date: this.initialDate,
          format: "YYYY-MM-DD",
        }),
        finalDate: DateUtils.toDateShortString({
          date: this.finalDate,
          format: "YYYY-MM-DD",
        }),
        type: this.formatType,
        query: this.query,
        userPurge: this.userPurge
      };
    },
    async validateForm() {
      // metodo que valida mis parametros en la interfaz grafica
      //para no hecer peticiones erroneas al servidor
      if (!this.finalDate || !this.initialDate) {
        throw new Error("Debe seleccionar fecha inicial y/o fecha final");
      }
      const validationResult = await this.$validator.validateAll();
      const validDates = DateUtils.isBefore({
        before: this.finalDate,
        date: this.initialDate,
      });
      if (validDates) {
        throw new Error("Fecha final no puede ser inferior a fecha inicial");
      }
      if (!validationResult) {
        throw new Error("Complete el formulario");
      }
      if (!this.companyId) {
        throw new Error("Seleccione una compañia");
      }
    },
    async download() {
      try {
        await this.validateForm();
        if (!this.formatType) {
          throw new Error(
              "Error debe seleccionar un tipo de formato para descargar"
          );
        }
        const params = this.prepareParameters();
        this.isLoading = true;
        toast.info("Cargando Reporte");
        parkingReportsEndpoints.downloadPurgeRecords(params)
            .then(data => {
              if (data.code < 0) {
                this.isLoading = false;
                return;
              }
              this.isLoading = false;
              let a = document.createElement("a");
              const urlFile =
                  process.env.VUE_APP_URL + ROUTES.GLOBAL.DOWNLOAD_FILE + data.info;
              a.href = urlFile;
              document.body.appendChild(a);
              console.log(urlFile);
              a.download = urlFile;
              a.click();
            });
      } catch (error) {
        toast.error(error.message);
      }
    },
    async listPurgeRecord() {
      try {
        await this.validateForm();
        this.tableData = [];
        this.isLoading = true;
        const params = this.prepareParameters();
        parkingReportsEndpoints.listPurgeRecords(params)
            .then(data => {
              if (data.info === null) {
                this.tableData = [];
                this.isLoading = false;
                this.showTable = true;
                return;
              }
              this.tableData = data.info;
              this.isLoading = false;
              this.showTable = true;
              this.forceRender++;
            });
      } catch (error) {
        toast.error(error.message);
      }
    },
    /// logica de paginacion de la tabla
    splitData() {
      if (!this.checkPages()) {
        this.tableData = this.originalData;
        return;
      }
      if (this.totalNumData <= this.forPageElements) {
        this.tableData = this.originalData;
        return;
      }
      // totalPages es el numero que da de paginas de mi tabla con el tope de  forPageElements
      this.totalPages = Math.ceil(this.lenghtData / this.forPageElements); /// forPageElements es el numero de  registros que yo quirero por pagina
      const offset = Math.round((this.page - 1) * this.forPageElements);
      const limit = Math.round(this.forPageElements * this.page);
      this.tableData = this.originalData.slice(offset, limit);
    },
    checkPages() {
      return this.lenghtData > this.forPageElements; // metodo que comprueba si la tabla nesecita paginacion o si los datos caben en una sola pagina
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"/>
